import { render } from "./AposInputRole.vue?vue&type=template&id=22a18ad2"
import script from "./AposInputRole.vue?vue&type=script&lang=js"
export * from "./AposInputRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"permission/ui/apos/components/AposInputRole.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22a18ad2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22a18ad2', __exports__)) {
    api.reload('22a18ad2', __exports__)
  }
  
  module.hot.accept("./AposInputRole.vue?vue&type=template&id=22a18ad2", () => {
    api.rerender('22a18ad2', render)
  })

}


export default __exports__